import { render, staticRenderFns } from "./QuoteCosts.vue?vue&type=template&id=47d6bf3e&scoped=true"
import script from "./QuoteCosts.vue?vue&type=script&lang=js"
export * from "./QuoteCosts.vue?vue&type=script&lang=js"
import style0 from "./QuoteCosts.vue?vue&type=style&index=0&id=47d6bf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6bf3e",
  null
  
)

export default component.exports